import { Autocomplete, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { Component } from "react";
import { httpGet, httpPost } from "../util/http";
import { MdClose } from "react-icons/md";
import BasicDataGrid from "./BasicDataGrid";
import QtdInput from "./QtdInput";
import CodProdInput from "./CodProdInput";
import DerivInput from "./DerivInput";

export default class ProdAdd extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            btnLoading: false,
            produto: {},
            codPro: '00000',
            deriv: '',
            showAdd: false,
            notFound: false,
        };
    }

    componentDidMount() {
        // this.setState({ loading: true });
        // httpGet('/produtos/inventario/' + this.props.inventario?.id,
        //     data => {
        //         console.log(data)
        //         this.setState({
        //             produtos: data,
        //             loading: false,
        //         });
        //     },
        //     error => {
        //         console.log(error);
        //         this.setState({ loading: false });
        //     },
        // );
    }

    search() {
        this.setState({ btnLoading: true, showAdd: false, notFound: false });
        httpGet('/produtos/prod?inventId=' + this.props.inventario?.id + '&codPro=' + this.state.codPro + '&deriv=' + this.state.deriv,
            produto => {
                console.log(produto)
                this.setState({
                    produto,
                    btnLoading: false,
                    showAdd: true,
                    notFound: false,
                });
            },
            error => {
                console.log(error);
                this.setState({ btnLoading: false, notFound: true });
            }
        );
    }

    render() {
        return (
            <Dialog maxWidth="500px" open={true} sx={{ zIndex: 99999 }}>
                <DialogTitle color="primary" fontSize={12}>ADICIONAR PRODUTO</DialogTitle>
                <IconButton sx={{ position: 'absolute', right: 8, top: 8 }} onClick={e => this.props.onClose(false)}>
                    <MdClose size={18} />
                </IconButton>
                <DialogContent>
                    <Stack minWidth="400px" gap={1}>
                        <Stack direction="row" gap={1} alignItems="center">
                            <CodProdInput value={this.state.codPro} onChange={codPro => this.setState({ codPro })} />
                            <DerivInput value={this.state.deriv} onChange={deriv => this.setState({ deriv })} />
                            {this.state.btnLoading ? <CircularProgress size={20} /> : <Button onClick={() => this.search()} size="small" color="success" variant="contained" disableElevation>Buscar</Button>}
                        </Stack>
                        {this.state.showAdd && <Typography variant="caption">{this.state.produto?.descricao}</Typography>}
                        {this.state.notFound && <Typography color="red" variant="caption">Produto não encontrado.</Typography>}
                    </Stack>
                </DialogContent>
                <DialogActions>
                    {this.state.showAdd && <Button size="small" color="success" onClick={() => { this.props.onAdd(this.state.produto) }}>Adicionar</Button>}
                </DialogActions>
            </Dialog>
        );
    }
}